import { type ReactNode } from 'react'

type AnimationDirection = 'up' | 'down' | 'left' | 'right' | 'none'

interface ILandingPageAnimatedContainerProps {
    children: ReactNode
    className?: string
    direction?: AnimationDirection
    delay?: number
    duration?: number
    distance?: number
    viewportMargin?: string
    once?: boolean
    ease?: number[] | string
    initialScale?: number
    mobileDistance?: number
    mobileDuration?: number
    mobileInitialScale?: number
    mobileDelay?: number
}

export function LandingPageAnimatedContainer({
    children,
    className,
}: ILandingPageAnimatedContainerProps) {
    return <div className={className}>{children}</div>
}

interface ILandingPageAnimatedStaggerProps {
    children: ReactNode
    className?: string
    staggerDelay?: number
    viewportMargin?: string
    once?: boolean
}

export function LandingPageAnimatedStagger({
    children,
    className,
}: ILandingPageAnimatedStaggerProps) {
    return <div className={className}>{children}</div>
}

interface ILandingPageAnimatedStaggerItemProps {
    children: ReactNode
    className?: string
    direction?: AnimationDirection
    duration?: number
    distance?: number
    ease?: number[] | string
}

export function LandingPageAnimatedStaggerItem({
    children,
    className,
}: ILandingPageAnimatedStaggerItemProps) {
    return <div className={className}>{children}</div>
}
